export enum AddChildStep {
  ChildType,
  RegisterChild,
}

export enum AddChildModalState {
  None,
  ConfirmConnect,
  AlreadyHasRelation,
  RequestAlreadySent,
  ChildAlreadyGenerated,
}

export const STEP_OPTIONS = [
  { value: 0, label: 'multiAccount_header_childType' },
  { value: 1, label: 'multiEntity_register' },
];

export type FirstStepForm = {
  username?: string;
  legality?: string;
  childType?: string;
};
